<section
  [class.bg-gray-light]="data.background === 'gray'"
  [class.bg-white]="data.background === 'white'"
  class="mask-curve-top relative py-14">
  <div class="centered-fullwidth grid grid-cols-1 desk:grid-cols-[350px_auto] desk:gap-x-12">
    <div class="centered-with-padding flex flex-col gap-y-5 desk:justify-center">
      @if (data.title; as title) {
        <app-title [title]="title" size="h2" />
      }
      @if (data.text; as text) {
        <div>{{ text }}</div>
      }
      @if (data.ctaOne; as ctaOne) {
        <app-button [label]="ctaOne.label" [url]="ctaOne.url" />
      }
      @if (data.ctaTwo; as ctaTwo) {
        <app-button [label]="ctaTwo.label" [url]="ctaTwo.url" />
      }
    </div>
    @if (data.video; as video) {
      <div class="pl-5 pt-5 desk:w-full desk:pl-0">
        <div
          class="mask-blob-cut-ratio-0_926 desk:mask-blob-ratio-1_278 flex size-full items-center justify-center desk:w-[780px]">
          <div class="aspect-4/3 size-full">
            <app-video [autoplay]="true" [isImagePriority]="!isImageInPreviousBlocks" [video]="video" />
          </div>
        </div>
      </div>
    }
  </div>
</section>
